// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
import { FIELD_TYPES } from "../../../../../../constants/template-field-type";
export default {
    text1: {
        type: FIELD_TYPES.TEXT,
        label: "Text 1",
        translatable: true
    },
    text2: {
        type: FIELD_TYPES.TEXT,
        label: "Text 2",
        translatable: true
    },
    text3: {
        type: FIELD_TYPES.TEXT,
        label: "Text 3",
        translatable: true
    },
    text5: {
        type: FIELD_TYPES.TEXT,
        label: "Text 5",
        translatable: true
    },
    text6: {
        type: FIELD_TYPES.TEXT,
        label: "Text 6",
        translatable: true
    },
    text7: {
        type: FIELD_TYPES.TEXT,
        label: "Text 7",
        translatable: true
    },
    title: {
        type: FIELD_TYPES.TEXT,
        label: "Title",
        translatable: true
    },
    image1: {
        type: FIELD_TYPES.NESTED,
        label: "Image 1",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    image2: {
        type: FIELD_TYPES.NESTED,
        label: "Image 2",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    image3: {
        type: FIELD_TYPES.NESTED,
        label: "Image 3",
        fields: {
            src: {
                type: FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    link1: {
        type: FIELD_TYPES.NESTED,
        label: "Link 1",
        fields: {
            href: {
                type: FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    link2: {
        type: FIELD_TYPES.NESTED,
        label: "Link 2",
        fields: {
            href: {
                type: FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    }
};
